export enum PresentationType {
    DistrictTable = "TABLE_DISTRICT_OVERVIEW",
    ElectionTable = "TABLE_ELECTION_OVERVIEW",
    SeatDistribution = "SEAT_DISTRIBUTION",
    SingleDistrict = "TABLE_SINGLE_COUNTY",
    SingleParty = "TABLE_SINGLE_PARTY",
    RemainderQuotients = "TABLE_REMAINDER_QUOTIENTS",
    LevellingSeats = "TABLE_LEVELLING_SEATS_OVERVIEW",
}

export enum DisproportionalityIndex {
    LOOSEMORE_HANBY = "LOOSEMORE_HANBY_INDEX",
    GALLAGHER = "GALLAGHER_INDEX",
}
